import { useCallback, useMemo, useState } from "react"
import styled from "styled-components"

type Props = {
    setCallback: (value: boolean) => void
    baseColor: "black" | "white"
    labelOn: string | JSX.Element
    labelOff: string | JSX.Element
    defaultValue: boolean
}

const Switcher = (props: Props) => {
    const [switcherOn, setSwitcherOn] = useState(props.defaultValue)

    const onSwitched = useCallback(() => {
        props.setCallback(!switcherOn)
        setSwitcherOn(!switcherOn)
    }, [props, switcherOn])

    const components = useMemo(() => {

        return (
            <>
                <div className="switcher-wrapper" onClick={onSwitched}>
                    <div className={`switcher-border ${props.baseColor} ${switcherOn ? 'on' : 'off'}`}>
                        <div className="switcher-body">
                            <div className={`switcher-content ${switcherOn ? 'on' : 'off'}`}>
                            </div>
                        </div>
                    </div>
                    <div className={`switcher-label ${props.baseColor} ${switcherOn ? 'on' : 'off'}`}>{switcherOn ? props.labelOn : props.labelOff}</div>
                    <div className={`switcher-shadow ${props.baseColor} ${switcherOn ? 'on' : 'off'}`}></div>
                </div>
            </>
        )
    }, [onSwitched, props.baseColor, props.labelOff, props.labelOn, switcherOn])

    return (
        <SwitcherStyle>
            {components}
        </SwitcherStyle>
    )
}

const SwitcherStyle = styled.div`
    .switcher-wrapper {
        position: relative;
        width: 80px;
        height: 25px;
        cursor: pointer;
        margin: 10px auto 10px auto;
        .switcher-border {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: center;
            width: 80px;
            height: 25px;
            clip-path: polygon(8px 100%, 0% 0%, 72px 0%, 100% 100%);
            &.on {
                background-color: red;
            }
            .switcher-body {
                margin: auto;
                width: 72px;
                height: 20px;
                clip-path: polygon(6.5px 100%, 0% 0%, 65.5px 0%, 100% 100%);
                .switcher-content {
                    width: 40px;
                    height: 25px;
                    &.on {
                        margin-left: 0;
                        text-align: right;
                        padding-right: 10px;
                        color: white;
                        background-color: red;
                    }
                    &.off {
                        margin: auto 0 auto auto;
                        text-align: left;
                        padding-left: 10px;
                    }
                }
            }
            &.black {
                &.off {
                    background-color: black;
                }
                .switcher-body {
                    background-color: white;
                    .switcher-content {
                        &.off {
                            color: white;
                            background-color: black;
                        }
                    }
                }
            }
            &.white {
                &.off {
                    background-color: white;
                }
                .switcher-body {
                    background-color: black;
                    .switcher-content {
                        &.off {
                            color: black;
                            background-color:  white;
                        }
                    }
                }
            }
        }
        .switcher-shadow {
            z-index: 0;
            position: absolute;
            width: 80px;
            height: 25px;
            clip-path: polygon(8px 100%, 0% 0%, 72px 0%, 100% 100%);
            background-color: red;
            top: 5px;
            left: 6px;
            &.on {
                &.black {
                    background-color: black;
                }
                &.white {
                    background-color: white;
                }
            }
        }
        .switcher-label {
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 100;
            position: absolute;
            font-size: 10px;
            width: 100px;
            top: -5px;
            width: 50px;
            height: 20px;
            &.on {
                color: white;
                background-color: red;
                transform: rotate(20deg);
                &.black {
                    box-shadow: 3px 3px 0 0 black;
                }
                &.white {
                    box-shadow: 3px 3px 0 0 white;
                }
            }
            &.off {
                transform: rotate(20deg);
                box-shadow: 3px 3px 0 0 red;
                &.black {
                    background-color: black;
                    right: 0;
                    color: white;
                }
                &.white {
                    background-color: white;
                    right: 0;
                    color: black;
                }
            }
        }
    }
`

export default Switcher